import { render, staticRenderFns } from "./BatimentAsset.vue?vue&type=template&id=35e90504"
import script from "./BatimentAsset.vue?vue&type=script&lang=js"
export * from "./BatimentAsset.vue?vue&type=script&lang=js"
import style0 from "./BatimentAsset.vue?vue&type=style&index=0&id=35e90504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports